import * as React from "react";
import { CandidateActionTypes, useCandidateActions } from "./candidate";
import { CandidateState } from "./candidateState";
import {
    ChangeStatusActionTypes,
    useStatusChangeActions,
} from "./statusChanges";
import { UiActionTypes, useUIActions } from "./ui";

export type CombinedCandidatesFeatureActionTypes =
    | UiActionTypes
    | CandidateActionTypes
    | ChangeStatusActionTypes;

export const useCombinedCandidatesFeatureActions = (
    state: CandidateState,
    dispatch: React.Dispatch<CombinedCandidatesFeatureActionTypes>
) => {
    const uiActions = useUIActions(state, dispatch);
    const candidateActions = useCandidateActions(state, dispatch);
    const statusChangeActions = useStatusChangeActions(state, dispatch);

    return {
        ...uiActions,
        ...candidateActions,
        ...statusChangeActions,
    };
};

export type FeatureActions = ReturnType<
    typeof useCombinedCandidatesFeatureActions
>;
